import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

interface InformationTooltipProps {
  tipContent?: any;
  hoverItem?: any;
  tipHeader?: string;
  tipBody?: string;
  tipImageURL?: string;
  variant?: "normal" | "custom";
  placement?: "top-start" | "top" | "top-end" | "left-start" | "left" | "left-end" | "right-start" | "right" | "right-end" | "bottom-start" | "bottom" | "bottom-end"
}

const NormalTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff',
    color: theme.palette.grey[900],
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    padding: "1rem",
    maxWidth: 272
  },
}))(Tooltip);

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff',
    color: theme.palette.grey[900],
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    padding: "1rem",
    maxWidth: "100%"
  },
}))(Tooltip);

const InformationTooltip: React.FC<InformationTooltipProps> = ({
  tipContent,
  hoverItem,
  tipHeader,
  tipBody,
  variant = "normal",
  placement
}) => {
  return (
    <div>
      {variant === "normal" ? 
        <NormalTooltip
          placement={placement || "top"}
          title={<React.Fragment>
              <Typography variant='subtitle1'>
                {tipHeader}
              </Typography>
              <Typography variant='subtitle2' style={{marginTop: "0.5rem"}}>
                {tipBody}
              </Typography>
            </React.Fragment>
          }
        >
          {hoverItem}
        </NormalTooltip>
      :
        <CustomTooltip
          placement={placement || "top"}
          title={
            <React.Fragment>
              {tipContent}
            </React.Fragment>
          }
        >
          {hoverItem}
        </CustomTooltip>
      }
    </div>
  );
};

export default InformationTooltip;